import cx from 'clsx';
import { FC, memo } from 'react';

import { Links } from './Links';
import { menu } from './menu';
import styles from './styles.module.css';

type Props = {
  opened: boolean;
};

export const NavBar: FC<Props> = memo(({ opened }) => {
  const links = menu.map((item) => (
    <Links {...item} key={item.label} opened={opened} />
  ));

  return (
    <nav
      className={cx({
        [styles.navbar]: true,
        [styles.navbarClosed]: !opened,
      })}
    >
      <div
        className={cx({
          [styles.content]: true,
          [styles.contentClosed]: !opened,
        })}
      >
        <div className={styles.menu}>{links}</div>
      </div>
    </nav>
  );
});
